import * as yup from "yup";

export const investment_report_schema = {
  asset_class: "",
  product: "",
  year: "",
  month: "",
  report_type: "",
};

export const investment_report_validation_schema = yup.object().shape({
  asset_class: yup.object().required("asset_class_required"),
  product: yup.object().required("product_required"),
  year: yup.object().required("year_required"),
  month: yup.object().required("month_required"),
  report_type: yup.object().required("report_type_required"),
});
